export class Controller {

    /** @ngInject */
    constructor(
        SaaspassConnectService,
        Alert,
        $state
        ) {
        this.Alert= Alert;
        this.$state= $state;
        this.SaaspassConnectService = SaaspassConnectService;
    }

    $onInit() {
        this.newAuthAccessSettings = angular.copy(this.authenticationAccessPolicyList);
        
        if (this.connectApplication.accessPolicy) {
            this.selectedPolicyId = this.connectApplication.accessPolicy.id;
        } else {
            this.selectedPolicyId = '-1';
        }
    }

    saveDisabled() {
        return this.isSaving || this.notModified();
    }

    notModified() {
        return (this.connectApplication.accessPolicy == null && this.selectedPolicyId == -1) || (this.connectApplication.accessPolicy != null && this.connectApplication.accessPolicy.id === this.selectedPolicyId);
    }

    saveAuthPolicy(){
        this.isSaving = true;
        this.SaaspassConnectService.applyPolicy({
            companyId: this.companyId,
            id: this.connectApplication.id,
            policyId: this.selectedPolicyId
        }, {}).$promise
        .then(()=>{
                this.Alert(
                    'success',
                    'company.policies.settings_updated'
                )
            })
        .then(() => this.$state.reload('company.saaspass-connect.manage'))
        .finally(() => {
            this.isSaving = false
        })
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/saaspass-connect/manage/access-control-policy/oidc-access-control-policy.controller.js